'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _TargetDateSeriesAllNamesTickers = require('./TargetDateSeriesAllNamesTickers.css');

var _TargetDateSeriesAllNamesTickers2 = _interopRequireDefault(_TargetDateSeriesAllNamesTickers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateSeriesAllNamesTickers = (_dec = (0, _reactCssModules2.default)(_TargetDateSeriesAllNamesTickers2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesAllNamesTickers, _Component);

  function TargetDateSeriesAllNamesTickers(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesAllNamesTickers);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesAllNamesTickers.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesAllNamesTickers)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesAllNamesTickers, [{
    key: 'render',
    value: function render() {
      var targetDateSeries = this.props.targetDateSeries;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { styleName: 'all-list-headline' },
            'All funds in this target date series'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'all-list-copy' },
            'A ',
            _react2.default.createElement(
              'b',
              null,
              'target date fund series'
            ),
            ' consist of around 10 or 12 different funds, each with their own "target date" marketed at different age demographics. We use the 2050 fund to assign ratings to target date fund series - this is the fund that would be marketed to savers looking to retire around the year 2050. As time progresses and this "target date" approaches, the portfolio mix of the fund shifts away from stocks and towards bonds and other less-risky investments. Usually, the mix of stocks in the portfolio stays the same across a target date fund series, meaning if you are invested in a fund from this target date series that is dated closer to today than 2050, you\'re likely invested in the same companies flagged above, but you may have lower levels of exposure. We currently only have detailed results for the 2050 version of this target date fund series.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'all-tickers-flex' },
            targetDateSeries.strategy_fund_legal_names.split(', ').map(function (e, i) {
              return _react2.default.createElement(
                'div',
                { key: 'tds-sfln-' + i, styleName: 'all-tickers-item' },
                e
              );
            })
          )
        ),
        targetDateSeries.strategy_tickers && targetDateSeries.strategy_tickers.length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { styleName: 'all-list-headline' },
            'All tickers for this target date series'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'all-list-copy' },
            'Tickers for each shareclass available from every fund in this target date series.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'all-tickers-flex' },
            targetDateSeries.strategy_tickers.split(', ').map(function (e, i) {
              return _react2.default.createElement(
                'div',
                { key: 'tds-tcks-' + i, styleName: 'all-tickers-item' },
                e
              );
            })
          )
        ) : null
      );
    }
  }]);
  return TargetDateSeriesAllNamesTickers;
}(_react.Component), _class2.propTypes = {
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesAllNamesTickers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesAllNamesTickers/TargetDateSeriesAllNamesTickers.js
// module id = 1444
// module chunks = 0